import { render, staticRenderFns } from "./cognition_report.vue?vue&type=template&id=0ddbb9ba&scoped=true"
import script from "./cognition_report.vue?vue&type=script&lang=js"
export * from "./cognition_report.vue?vue&type=script&lang=js"
import style0 from "./cognition_report.vue?vue&type=style&index=0&id=0ddbb9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddbb9ba",
  null
  
)

export default component.exports